import type { JSX, ReactNode } from 'react'

// Marqueurs de la légende supply, partagés entre le back-office (barre de contrôles + modale
// « Légende ») et le store-app (en-tête du widget « Flux supply en temps réel »). Extraits tels
// quels de supply-controls-row.tsx : mêmes SVG, mêmes cotes, rendu back-office inchangé.

export const BOXED_ICON_SIZE = 10.667

export function BarsMark({ color, rising }: { color: string; rising: boolean }): JSX.Element {
  return (
    <svg width="10" height="13" viewBox="0 0 10 13" fill="none" aria-hidden="true">
      <path d="M1 2L1 12" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path d="M5 4.14551L5 12" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path
        d={rising ? 'M9 1L9 12' : 'M9 7L9 12'}
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function DashedMark({ color }: { color: string }): JSX.Element {
  return (
    <svg width="18" height="2" viewBox="0 0 18 2" fill="none" aria-hidden="true">
      <line
        x1="0.5"
        y1="1"
        x2="17.5"
        y2="1"
        stroke={color}
        strokeLinecap="round"
        strokeDasharray="2 2"
      />
    </svg>
  )
}

export function BoxedMark({
  color,
  children,
}: {
  color: string
  children: ReactNode
}): JSX.Element {
  return (
    <span
      className="flex items-center rounded-[6.667px] border-[0.667px] bg-white p-[2.667px]"
      style={{ borderColor: color, color }}
      aria-hidden="true"
    >
      {children}
    </span>
  )
}
